'use strict';

var operatorsParser = require('./pegjs/pricing-operator-parser');
var FpMarketConfigParsingService = function FpMarketConfigParsingService($filter, momentService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var VALUE_SUFFIX = '_value';
  var OPERATOR_SUFFIX = '_operator';
  var OPERATORS = {
    '<': 'lt',
    '<=': 'lte',
    '>': 'gt',
    '>=': 'gte',
    '=': 'eq',
    '!=': 'neq'
  };
  function formatInputNumber(value) {
    return parseInt(value);
  }
  function formatInputDate(value) {
    return momentService.of(value, momentService.FIELD.PRICING_DEPARTURE_DATE, momentService.FORMAT.YEAR_MONTH_DAY_NOT_SEPARATED);
  }
  function formatInputValue(value, type) {
    return type === 'date' ? formatInputDate(value) : formatInputNumber(value);
  }
  function splitParsedField(row, baseKey, type) {
    var propertyValue = row[baseKey];
    var parsedValue = propertyValue ? operatorsParser.parse(propertyValue).split(' ') : ['', ''];
    row[baseKey + OPERATOR_SUFFIX] = parsedValue[0];
    row[baseKey + VALUE_SUFFIX] = formatInputValue(parsedValue[1], type);
    delete row[baseKey];
  }
  function splitParsedNumber(row, baseKey) {
    splitParsedField(row, baseKey);
  }
  function splitParsedDate(row, baseKey) {
    splitParsedField(row, baseKey, 'date');
  }
  function translateOperator(operator) {
    return OPERATORS[operator];
  }
  function formatOutputValue(value, type) {
    return type === 'date' ? rmMomentFormat(value, 'YEAR_MONTH_DAY_NOT_SEPARATED') : value;
  }
  function mergeParsedValue(row, baseKey, type) {
    row[baseKey] = translateOperator(row[baseKey + OPERATOR_SUFFIX]) + formatOutputValue(row[baseKey + VALUE_SUFFIX], type);
    delete row[baseKey + OPERATOR_SUFFIX];
    delete row[baseKey + VALUE_SUFFIX];
  }
  function mergeParsedNumber(row, baseKey) {
    mergeParsedValue(row, baseKey);
  }
  function mergeParsedDate(row, baseKey) {
    mergeParsedValue(row, baseKey, 'date');
  }
  function parseBoolean(row, baseKey) {
    row[baseKey] = row[baseKey] === 'Yes';
  }
  return {
    splitParsedNumber: splitParsedNumber,
    splitParsedDate: splitParsedDate,
    mergeParsedNumber: mergeParsedNumber,
    mergeParsedDate: mergeParsedDate,
    parseBoolean: parseBoolean
  };
};
FpMarketConfigParsingService.$inject = ['$filter', 'MomentService'];
module.exports = FpMarketConfigParsingService;